import axios from 'axios';
import { get, post, put, remove } from './mainApi';

const defineLeaveBaseUrl = process.env.REACT_APP_DEFINE_LEAVE_MANAGEMENT_ENDPOINT;

  export const getAllDefineLeaves = async () => {
    let response = get(`${defineLeaveBaseUrl}`);
    return response;
  };

  export const createDefineLeaves = async (defineLeave) => {
    let response = post(`${defineLeaveBaseUrl}`,defineLeave);
    return response;
  };

  export const updateDefineLeaves = async (defineLeave) => {
    let response = put(
      `${defineLeaveBaseUrl}${defineLeave.id}`,defineLeave);
    return response;
  };

  export const deleteDefineLeaves = async (id) => {
    let response = remove(
      `${defineLeaveBaseUrl}${id}`
    );
    return response;
  };
  
  export const searchDefineLeave = async (employmentType) => {
    let response = get(
      `${defineLeaveBaseUrl}search?keyword=${employmentType}`
    );
    return response;
  };

  export const getAllLeaveTypeNames = async () => {
    let response = get(
      `${defineLeaveBaseUrl}names`);
    return response;
  };
